export default {
  // Endpoints
  endpoints: {
    login: 'admin/auth/login',
    register: 'Auth/register',
    refresh: 'Auth/refreshToken',
    logout: 'Auth/logout',
    sendCode: 'admin/auth/sendCode',
    referral: {
      setReferralUser: 'referral/setReferralUser',
      getReferredUser: 'referral/GeReferredUsers',
    },
  },

  loginInstance: {
    phoneNumber: String,
    code: Number,
    password: String,
  },

  urlDefinition: {
    service: '',
    version: 1,
  },

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storage: {
    tokenKey: 'accessToken',
    user: 'user',
    refreshTokenKey: 'refreshToken',
    tokenExpiration: 'tokenExp',
  },
};
